<template>
  <v-list dense>
    <div v-if="mode != 'production'">
      <div class="text-primary:">{{ $t('assignaments.designers') }}</div>
      <ul>
        <li
          v-for="assignItem in selectedItem"
          :key="`${mode}-${assignItem.pk}`"
          class="text-aux font-weight-normal"
          @click.stop="open()"
        >
          {{ `${assignItem.first_name} ${assignItem.last_name}` }}
        </li>
      </ul>
    </div>
    <div v-else>
      <div class="text-primary:">{{ $t('assignaments.department') }}</div>
      <ul>
        <li class="text-aux font-weight-normal">{{ department?.name }}</li>
      </ul>
    </div>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    selectedItem: {
      required: true,
      type: [String, Number, Array]
    },
    mode: {
      default: 'designer',
      type: [String]
    },
    department: {
      default: () => [],
      type: [Object]
    }
  },
  data() {
    return {
      assignItems: [],
      avalaible: 0,
      reload: false,
      dialog: false,
      toEdit: null
    }
  },
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog =
        this.getPermissions([`sales.change_assigneduser`]) || this.isAdmin
      this.$refs.dialassignitem.open()
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    })
  }
}
</script>

<style lang="sass">
.infoAssignItem
  background-color: rgb(200 200 200 / .3)
  display: flex
  flex-direction: column
  align-items: baseline
  flex-wrap: wrap
  gap: 8px
.theme--dark
  .infoAssignItem
    background-color: rgb(0 0 0 / .25)
</style>
